import moment from 'moment-timezone';

import {
  HostingVisitors200,
  HostingVisitors200DailyDataItem,
  HostingVisitors200VisitorsItem,
} from '@newfold/huapi-js/src/index.schemas';

export const visitorsList: HostingVisitors200VisitorsItem[] = [
  {
    interval_end: '2025-03-05 15:40:49',
    interval_start: '2025-03-05 14:40:49',
    bandwidth: 0,
    hits: 0,
    visitors: 0,
    unique_visitors: 0,
  },
  {
    interval_end: '2025-03-05 16:40:49',
    interval_start: '2025-03-05 15:40:49',
    bandwidth: 100,
    hits: 1,
    visitors: 1,
    unique_visitors: 1,
  },
  {
    interval_end: '2025-03-05 17:40:49',
    interval_start: '2025-03-05 16:40:49',
    bandwidth: 200,
    hits: 2,
    visitors: 2,
    unique_visitors: 2,
  },
  {
    interval_end: '2025-03-05 18:40:49',
    interval_start: '2025-03-05 17:40:49',
    bandwidth: 300,
    hits: 3,
    visitors: 3,
    unique_visitors: 3,
  },
  {
    interval_end: '2025-03-05 19:40:49',
    interval_start: '2025-03-05 18:40:49',
    bandwidth: 400,
    hits: 4,
    visitors: 4,
    unique_visitors: 4,
  },
  {
    interval_end: '2025-03-05 20:40:49',
    interval_start: '2025-03-05 19:40:49',
    bandwidth: 500,
    hits: 5,
    visitors: 5,
    unique_visitors: 5,
  },
  {
    interval_end: '2025-03-05 21:40:49',
    interval_start: '2025-03-05 20:40:49',
    bandwidth: 600,
    hits: 6,
    visitors: 6,
    unique_visitors: 6,
  },
  {
    interval_end: '2025-03-05 22:40:49',
    interval_start: '2025-03-05 21:40:49',
    bandwidth: 700,
    hits: 7,
    visitors: 7,
    unique_visitors: 7,
  },
  {
    interval_end: '2025-03-05 23:40:49',
    interval_start: '2025-03-05 22:40:49',
    bandwidth: 800,
    hits: 8,
    visitors: 8,
    unique_visitors: 8,
  },
  {
    interval_end: '2025-03-06 00:40:49',
    interval_start: '2025-03-05 23:40:49',
    bandwidth: 900,
    hits: 9,
    visitors: 9,
    unique_visitors: 9,
  },
  {
    interval_end: '2025-03-06 01:40:49',
    interval_start: '2025-03-06 00:40:49',
    bandwidth: 1000,
    hits: 10,
    visitors: 10,
    unique_visitors: 10,
  },
  {
    interval_end: '2025-03-06 02:40:49',
    interval_start: '2025-03-06 01:40:49',
    bandwidth: 1000,
    hits: 10,
    visitors: 10,
    unique_visitors: 10,
  },
  {
    interval_end: '2025-03-06 03:40:49',
    interval_start: '2025-03-06 02:40:49',
    bandwidth: 1100,
    hits: 11,
    visitors: 11,
    unique_visitors: 11,
  },
  {
    interval_end: '2025-03-06 04:40:49',
    interval_start: '2025-03-06 03:40:49',
    bandwidth: 1200,
    hits: 12,
    visitors: 12,
    unique_visitors: 12,
  },
  {
    interval_end: '2025-03-06 05:40:49',
    interval_start: '2025-03-06 04:40:49',
    bandwidth: 1300,
    hits: 13,
    visitors: 13,
    unique_visitors: 13,
  },
  {
    interval_end: '2025-03-06 06:40:49',
    interval_start: '2025-03-06 05:40:49',
    bandwidth: 1400,
    hits: 14,
    visitors: 14,
    unique_visitors: 14,
  },
  {
    interval_end: '2025-03-06 07:40:49',
    interval_start: '2025-03-06 06:40:49',
    bandwidth: 1500,
    hits: 15,
    visitors: 15,
    unique_visitors: 15,
  },
  {
    interval_end: '2025-03-06 08:40:49',
    interval_start: '2025-03-06 07:40:49',
    bandwidth: 1600,
    hits: 16,
    visitors: 16,
    unique_visitors: 16,
  },
  {
    interval_end: '2025-03-06 09:40:49',
    interval_start: '2025-03-06 08:40:49',
    bandwidth: 1700,
    hits: 17,
    visitors: 17,
    unique_visitors: 17,
  },
  {
    interval_end: '2025-03-06 10:40:49',
    interval_start: '2025-03-06 09:40:49',
    bandwidth: 1800,
    hits: 18,
    visitors: 18,
    unique_visitors: 18,
  },
  {
    interval_end: '2025-03-06 11:40:49',
    interval_start: '2025-03-06 10:40:49',
    bandwidth: 1900,
    hits: 19,
    visitors: 19,
    unique_visitors: 19,
  },
  {
    interval_end: '2025-03-06 12:40:49',
    interval_start: '2025-03-06 11:40:49',
    bandwidth: 2000,
    hits: 20,
    visitors: 20,
    unique_visitors: 20,
  },
  {
    interval_end: '2025-03-06 13:40:49',
    interval_start: '2025-03-06 12:40:49',
    bandwidth: 2100,
    hits: 21,
    visitors: 21,
    unique_visitors: 21,
  },
  {
    interval_end: '2025-03-06 14:40:49',
    interval_start: '2025-03-06 13:40:49',
    bandwidth: 2200,
    hits: 22,
    visitors: 22,
    unique_visitors: 22,
  },
];

export const dailyData: HostingVisitors200DailyDataItem[] = [
  {
    date: moment().subtract(1, 'day').format('YYYY-MM-DD'),
    bandwidth: 100000,
    hits: 20,
    visits: 10,
    pages: 5,
  },
];

export const visitorsResponse: HostingVisitors200 = {
  visitors: visitorsList,
  daily: {
    data: dailyData,
    total: {
      total_bandwidth: 100000,
      total_hits: 100,
      total_pages: 10,
      total_visitors: 50,
    },
  },
  total_bandwidth: 200000,
  total_hits: 200,
  total_pages: 20,
  total_unique_visitors: 40,
  total_visitors: 0,
};
